import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Login from '../components/Login/Login'

const Sign = () => {
  return (
    <div>
        <Navbar/>
        <Login/>
        </div>
  )
}

export default Sign